import { useTranslate } from "@similarweb/i18n-provider";
import { Check } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { useDemoModeAccessRequest } from "app/pages/sales-intelligence/hooks/demo-mode/useDemoModeAccessRequest";
import demoModeTrackingService from "app/pages/sales-intelligence/services/tracking/demo-mode/trackingService";
import type { IDemoSession } from "app/pages/sales-intelligence/types/demo-mode";
import { demoModeKeys } from "app/pages/sales-intelligence/utils/i18n/demo-mode";

import { CTA_HEIGHT_PX } from "./styles";

interface IProps {
    readonly demo: IDemoSession;
}

export const DemoModeAccessRequestCta = ({ demo }: IProps) => {
    const { translate } = useTranslate();

    const { isSent, isPending, requestAccess } = useDemoModeAccessRequest(demo);

    if (isSent) {
        return (
            <Flex
                data-automation="demo-mode-banner-request-sent"
                inline
                alignItems="center"
                gap="6px"
            >
                <Check
                    size="xs"
                    color={colorsPalettes.carbon[0]}
                />
                <Text
                    fontVariant="subtitle2"
                    color={colorsPalettes.carbon[0]}
                >
                    {translate(demoModeKeys.accessRequestSent)}
                </Text>
            </Flex>
        );
    }

    const handleClick = () => {
        demoModeTrackingService.trackBannerCtaClick(demo.id);
        requestAccess();
    };

    return (
        <Button
            data-automation="demo-mode-banner-cta"
            type="inverted"
            buttonHtmlType="button"
            width="max-content"
            height={CTA_HEIGHT_PX}
            isDisabled={isPending}
            onClick={handleClick}
        >
            {translate(demoModeKeys.bannerCta(demo.copyNamespace))}
        </Button>
    );
};
